export const fullBarYellow = '#ffe81a';
export const barBackgroundLightGreen = '#d7fff7';
export const fullBarBackgroundDeepPink = '#e8178a';
export const fullBarBackgroundLightPink = '#f778bc';
export const firstBarYellow = '#fbe600';
